<template>
  <div class="section-hero">
    <!-- 파란색 그라디언트 배경 -->
    <div class="hero-background">
      <div class="hero-content">
        <!-- 아이콘 -->
        <div class="hero-icon">
          <safety-certificate-outlined style="font-size: 40px; color: #fff;" />
        </div>

        <!-- 제목/부제목 -->
        <h1 class="hero-title">{{ displayData.title }}</h1>
        <p class="hero-subtitle">{{ displayData.subtitle }}</p>

        <!-- CTA 버튼 -->
        <div class="hero-cta">
          <a-button type="primary" size="large" class="cta-button">
            {{ displayData.ctaText }}
          </a-button>
        </div>

        <!-- 히어로 이미지 영역 -->
        <div class="hero-image-area">
          <div v-if="displayData.heroImage" class="hero-image">
            <img :src="displayData.heroImage" alt="hero" style="max-width: 100%; border-radius: 12px;" />
          </div>
          <div v-else class="hero-image-placeholder">
            <picture-outlined style="font-size: 48px; color: rgba(255,255,255,0.5);" />
            <span style="color: rgba(255,255,255,0.5); margin-top: 8px;">히어로 이미지</span>
          </div>
        </div>

        <!-- 탭 네비게이션 -->
        <div v-if="displayData.tabs && displayData.tabs.length" class="hero-tabs">
          <div
            v-for="(tab, idx) in displayData.tabs"
            :key="idx"
            class="hero-tab-item"
          >
            {{ tab.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SafetyCertificateOutlined, PictureOutlined } from '@ant-design/icons-vue';

// 기본 데이터
const DEFAULT_DATA = {
  title: '메디컬 인증서 기반 고객관리 플랫폼 서티라이프',
  subtitle: '인증서 발행부터 AI 채팅 상담, CRM 마케팅까지 서티라이프에서 시작하세요',
  ctaText: '도입 문의하기 →',
  ctaUrl: '',
  heroImage: '',
  tabs: [
    { name: '정품 인증서', link: '' },
    { name: 'AI 상담', link: '' },
    { name: 'CRM 마케팅', link: '' },
    { name: '이벤트 마케팅', link: '' },
  ],
};

export default {
  name: 'SectionHero',

  components: {
    SafetyCertificateOutlined,
    PictureOutlined,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    displayData() {
      return { ...DEFAULT_DATA, ...this.data };
    },
  },
};
</script>

<style scoped>
.section-hero {
  border-radius: 0 0 28px 28px;
  overflow: hidden;
}

.hero-background {
  background: radial-gradient(ellipse at top center, rgba(204, 213, 252, 1) 0%, rgba(19, 61, 122, 1) 100%);
  padding: 60px 24px 40px;
}

.hero-content {
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
}

.hero-icon {
  margin-bottom: 16px;
}

.hero-title {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 12px;
}

.hero-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 24px;
}

.hero-cta {
  margin-bottom: 32px;
}

.cta-button {
  background: #141c26 !important;
  border-color: #141c26 !important;
  border-radius: 8px;
  padding: 0 28px;
  height: 44px;
  font-size: 15px;
  font-weight: 600;
}

.hero-image-area {
  margin-bottom: 24px;
}

.hero-image-placeholder {
  width: 350px;
  height: 194px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed rgba(255, 255, 255, 0.3);
}

.hero-tabs {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.hero-tab-item {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  color: #fff;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
</style>
